<template>
  <div><slot></slot></div>
</template>
<script lang="ts">
import { Component } from 'vue-property-decorator';
import BaseComponent from './Base';

@Component
export default class NavTab extends BaseComponent {
  private CSS_PREFIX = 'c-nav-tab';

  protected mounted(): void {
    this.toggleActive(this.$el.querySelector(`.${ this.CSS_PREFIX }__nav .${ this.CSS_PREFIX }__nav-item:first-child`));
    this.$el.querySelectorAll(`.${ this.CSS_PREFIX }__nav .${ this.CSS_PREFIX }__nav-item`).forEach((el) => {
      // el.addEventListener('mouseover', () => this.toggleActive(el as HTMLElement));
      el.addEventListener('click', () => this.toggleActive(el as HTMLElement));
    });
  }

  private toggleActive(tab: HTMLElement | null): void {
    const id = tab ? tab.dataset.menuId : null;
    this.$el.querySelectorAll(`.${ this.CSS_PREFIX }__nav .${ this.CSS_PREFIX }__nav-item`).forEach((el) => {
      el.classList.toggle(`${ this.CSS_PREFIX }__nav-item--active`, (el as HTMLElement).dataset.menuId === id);
    });
    this.$el.querySelectorAll(`.${ this.CSS_PREFIX }__section`).forEach((el) => {
      el.classList.toggle(`${ this.CSS_PREFIX }__section--expanded`, el.id === id);
    });
  }
}
</script>
